export default { auth: 
  {
    login: { method: 'post', url: 'login' },
    recover: { method: 'post', url: 'recover' },
    changePassword: { method: 'post', url: 'changePassword' },
    loadSession: { method: 'post', url: 'load-session' },
    getDfes: { method: 'post', url: 'dfes' },
    getUsers: { method: 'post', url: 'getUsers' },
    putUsers: { method: 'put', url: 'users' },
    postUsers: { method: 'post', url: 'users' },
    representantes: { method: 'get', url: 'representantes' },
    contadores: { method: 'get', url: 'contadores' },
    postContador: { method: 'post', url: 'contador' },
    todosContadores: { method: 'get', url: 'todos-contadores' },
    getEmitentes: { method: 'get', url: 'emitentes' },
    downloadDfes: { method: 'post', url: 'downloadDfes', responseType: 'blob' },
    totaisDfe: { method: 'get', url: 'totaisDfe', },
    emitentesAtivo: { method: 'post', url: 'emitentes-ativo' }
  }
}
